import { Component, OnInit, TemplateRef  } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import * as moment from 'moment';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { LoginService } from 'src/app/modules/admin/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public buttonLoader: any = false;

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _loginService: LoginService
  ) {}

  ngOnInit(): void {
    // Set login form
    this.loginForm = new FormGroup({
      username: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      password: new FormControl(null, [Validators.required, Validators.minLength(3)]),
    });
  }

  // Login submit
  async onLogin() {
    /*let responseSetStorageDataA_LOGIN = await this._utilService.setStorageData('A_LOGIN', {
      status: true,
      token: 'xxx',
      user_details: {
        user_id: '2',
        user_name: 'Sebastian George',
        user_email: 'sebastian@retail10x.com',
        user_timezone: -8
      },
      menu: [{menu_id: 1, menu_code: 'A-TCB', menu_name: 'TCB Coupons', route: '/admin/tcb', menu_icon: 'faCirclePlus'}]
    });
    this._router.navigate(['/admin/tcb']); // Go to admin TCB section
    return false;*/
    
    if (this.loginForm.value.username && this.loginForm.value.password) {
      let loginBody = {
        username: this.loginForm.value.username,
        password: this.loginForm.value.password
      };

      this.buttonLoader = true;

      // Check username & password
      this._loginService.login(loginBody).subscribe(async loginResponse => {
        this.buttonLoader = false;

        if (loginResponse.status === true) { // Success
           // Add login data to local storage
           let responseSetStorageDataA_LOGIN = await this._utilService.setStorageData('A_LOGIN', loginResponse);

          if (responseSetStorageDataA_LOGIN) {
            this._router.navigate(['/admin/tcb']); // Go to admin TCB section
          } else {
            this._utilService.showToast('Error while saving login data', '', 'error', {});
          }
        } else {
          this.buttonLoader = false;
          this._utilService.showToast(loginResponse.message, '', 'error', {});
        }
      }, error1 => { // Error from userLogin
        this.buttonLoader = false;
        this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
      });
    } else {
      this._utilService.showToast('Please enter username and password', '', 'warning', {});
    }
  }

}
